const Title = (props) => {

  const colorTitle = {
    color: props.color,
    whiteSpace: props.wrap,
    position: props.position,
    top: props.top,
    left: props.left
  }
  return <div className="flex flex-nowrap justify-center items-end font-unbounded text-3xl 2sm:text-2xl md:text-4xl lg:text-5xl text-center font-bold pointer-events-none w-3/4 bg-transparent">
    <h2 style={colorTitle} className='sm:mx-6'>{props.text}<hr className='inline-block h-3 w-3 bg-orange text-orange ml-1'></hr></h2>
  </div>
}

export default Title